import {
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  GET_BANNER_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const Banner = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_BANNERS:
      return {
        ...state,
        loading: true,
      };
    case GET_BANNERS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_BANNER_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_BANNERS_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default Banner;
